import type { ReactNode } from 'react'

export interface SplitPanel {
  title: string
  descr: string
  /** Bullets under the copy. Omit for a panel whose action is a form. */
  list?: string[]
  /** Whatever the panel asks the reader to do — a button, a form, a picker. */
  action?: ReactNode
}

export interface SplitPanelsProps {
  left: SplitPanel
  right: SplitPanel
}

/**
 * The `.ul-volunteer` band: two panels side by side, each making a different ask.
 *
 * It closes a page in three of the four apps — the Foundation's donations page (volunteer
 * / give), the resort's overview (visit / partner) and the garage's (walk in / mentor) —
 * and it was the same twenty-five lines of markup in each. One definition, in the system.
 *
 * The right panel carries `ul-donate-form-wrapper-2` because the second panel is the
 * darker of the two in the stylesheet; that is a position, not a statement about
 * donations, and it stays true whatever the panel holds.
 */
export function SplitPanels({ left, right }: SplitPanelsProps) {
  return (
    <section className="ul-volunteer ul-section-spacing">
      {/*
        A container and a gutter, where this used to be a full-bleed `g-0` row of two
        photographs. See `_volunteer.scss` for why.
      */}
      <div className="ul-container">
        <div className="row row-cols-md-2 row-cols-1 ul-bs-row">
        {[left, right].map((panel, i) => (
          <div className="col" key={panel.title}>
            <div className={i === 1 ? 'ul-volunteer-block ul-donate-form-wrapper-2' : 'ul-volunteer-block'}>
              <h2 className="ul-volunteer-title">{panel.title}</h2>
              <p className="ul-volunteer-descr">{panel.descr}</p>
              {panel.list && panel.list.length > 0 && (
                <ul className="ul-volunteer-list">
                  {panel.list.map((item, j) => (
                    <li key={`${item}-${j}`}>{item}</li>
                  ))}
                </ul>
              )}
              {panel.action}
            </div>
          </div>
        ))}
        </div>
      </div>
    </section>
  )
}
